import styled, { css } from 'styled-components/macro';

export const ImageContainer = styled.div<{ selected: boolean }>`
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 2px;
  position: relative;

  ${({ selected }) =>
    css`
      border: 2px solid ${selected ? '#1402cc' : 'darkgray'};
    `}
`;

export const AddButton = styled.div`
  align-items: center;
  border: 2px dotted lightgrey;
  color: darkgray;
  cursor: pointer;
  display: flex;
  height: 93px;
  justify-content: center;
  margin-bottom: 0.5rem;
  position: relative;
  text-align: center;
  width: 158px;
`;

export const UploadProgress = styled.div<{ progress: number }>`
  background: green;
  height: 6px;
  position: absolute;
  left: 0;
  bottom: 0;

  ${({ progress }) =>
    progress > 0 &&
    css`
      border: 1px solid white;
      width: ${progress}%;
    `}
`;
